/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const login = (username, password, company_id) => {
  return API.post(`${getApiUrl()}/api/auth/login`, {
    username,
    password,
    // company_id
    company_id: "000001"
  });
};

export const getUser = () => {
  return API.get(`${getApiUrl()}/api/auth/get-user`);
};

export const changePassword = (newPassword, currentPassword) => {
  return API.post(`${getApiUrl()}/api/auth/change-password`, {
    new_password: newPassword,
    current_password: currentPassword
  });
};

export const authenService = {
  login,
  getUser,
  changePassword
};
